import React, { useState } from 'react';
import { usePermissions } from 'react-admin';
import { CreateButton } from '~/components';
import BusinessCreateDrawer from './components/BusinessCreateDrawer';

const BusinessCreateAction = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { permissions } = usePermissions();
  if (!permissions?.includes('business.create')) return null;
  return (
    <>
      <CreateButton onClick={handleOpen} />
      <BusinessCreateDrawer open={open} onClose={handleClose} />
    </>
  );
};

export default BusinessCreateAction;
